module.exports = __webpack_public_path__ + "img/zuopin2.9119e45a.jpg";